import { Box, Button, Flex, Heading, List } from "@chakra-ui/react";
import TableList from "components/TableList";

const headers = ["Item"];

const items = [
  {
    id: 1,
    Item: "200",
  },
];

function ClaimAmount() {
  const onNew = () => {};

  return (
    <Box>
      <Flex>
        <List.Root overflowY={"scroll"} h="100vh" w="100%" p="10">
          <Heading size="4xl" color="primary" mt="2.5" mb="2.5">
            Claim Amount
          </Heading>
          <Flex gap={"3"} justifyContent={"flex-end"}>
            <Button variant="outline" onClick={onNew}>
              New
            </Button>
          </Flex>
          <TableList headers={headers} items={items} />
        </List.Root>
      </Flex>
    </Box>
  );
}

export default ClaimAmount;
